import React from 'react';
import { Button } from '@mui/material';

interface AttachmentProps {
  attachment: any;
  handleClick: (attachmentId: string) => void;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  isLoading?: boolean;
}

const Attachment: React.FC<AttachmentProps> = ({
  attachment,
  handleClick,
  startIcon,
  endIcon,
  isLoading,
}) => {
  const handleButtonClick = () => {
    handleClick(attachment.attachmentId);
  };

  return (
    <Button
      onClick={handleButtonClick}
      startIcon={startIcon || null}
      endIcon={endIcon || null}
      data-testid="attachment-displayname"
      sx={{
        backgroundColor: 'grey.100',
        borderRadius: '20px',
        marginBottom: '10px',
        textTransform: 'none',
        color: 'grey.700',

        '& p': {
          color: 'grey.700',
          fontSize: 'smaller',
          fontWeight: 400,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        '& .MuiButton-endIcon': {
          color: 'link.main',
        },
      }}
    >
      {isLoading ? 'Loading...' : attachment.name || attachment.displayName}
    </Button>
  );
};

export default Attachment;
